<div class="info" appArrastarFecharSheet (arrastouParaFechar)="fechar()">
  <header class="info-topo">
    <div class="info-titulo-bloco">
      <span class="info-titulo">Atendimento #{{ atendimentoId }}</span>
      @if (detalhes(); as d) {
        <span class="at-status" [class.at-status-ativo]="d.ativo">{{ d.ativo ? 'Em andamento' : 'Encerrado' }}</span>
      }
    </div>
    <button type="button" class="info-btn-fechar at-btn-fechar" aria-label="Fechar" (click)="fechar()">
      <img src="./assets/icones/redesign/utils/close-gray.svg" alt="" />
    </button>
  </header>

  <div class="info-conteudo">
    @if (carregando()) {
      @for (bloco of [1, 2, 3]; track bloco) {
        <section class="info-card">
          <span class="skeleton info-skeleton"></span>
          <span class="skeleton info-skeleton at-skeleton-longo"></span>
          <span class="skeleton info-skeleton"></span>
        </section>
      }
    } @else if (erro() || !detalhes()) {
      <div class="at-erro">
        <span class="at-erro-titulo">Não foi possível carregar o atendimento</span>
        <span class="info-vazio">Tente novamente em alguns instantes.</span>
      </div>
    } @else {
      @let d = detalhes()!;
      <section class="info-card">
        <span class="info-card-titulo">Atendente</span>
        @if (d.operador?.nome) {
          <div class="info-operador">
            <app-avatar-pessoa [pessoa]="d.operador" [tamanho]="38"></app-avatar-pessoa>
            <div class="at-pessoa">
              <span class="info-operador-nome">{{ d.operador?.nome }}</span>
              @if (d.operador?.email) {
                <span class="at-pessoa-sub">{{ d.operador?.email }}</span>
              }
            </div>
          </div>
        } @else {
          <span class="info-vazio">Sem operador atribuído (chatbot).</span>
        }
      </section>

      <section class="info-card">
        <span class="info-card-titulo">Atendimento</span>
        <dl class="info-lista">
          <dt>ID</dt>
          <dd>{{ d.id }}</dd>

          <dt>Iniciado em</dt>
          <dd>{{ d.dataCriacao ? (d.dataCriacao | date: 'dd/MM/yyyy - HH:mm') : '-' }}</dd>

          <dt>Encerrado em</dt>
          <dd>{{ d.dataFim ? (d.dataFim | date: 'dd/MM/yyyy - HH:mm') : 'Em andamento' }}</dd>

          <dt>Duração</dt>
          <dd>{{ duracao() }}</dd>

          <dt>Origem</dt>
          <dd>
            <span class="info-valor-quebra">{{ d.origem?.descricao || '-' }}</span>
            @if (d.origem?.disparo?.nome) {
              <span class="at-sub-valor">{{ d.origem?.disparo?.nome }}</span>
            }
            @if (d.origem?.atendimentoAnteriorId) {
              <span class="at-sub-valor">Atendimento anterior #{{ d.origem?.atendimentoAnteriorId }}</span>
            }
          </dd>

          <dt>Contato</dt>
          <dd>
            <span class="info-valor-quebra">{{ d.contato?.nome || '-' }}</span>
            @if (d.numeroContato) {
              <span class="at-sub-valor">{{ d.numeroContato | celularMask }}</span>
            }
          </dd>
        </dl>
      </section>

      @if (d.sessao; as s) {
        <section class="info-card">
          <div class="at-card-topo">
            <span class="info-card-titulo">Sessão #{{ s.id }}</span>
            <span class="at-status" [class.at-status-ativo]="s.ativo">{{ s.ativo ? 'Aberta' : 'Fechada' }}</span>
          </div>
          <dl class="info-lista">
            <dt>Canal</dt>
            <dd>{{ s.canal?.nome || '-' }}</dd>

            <dt>Fluxo</dt>
            <dd><span class="info-valor-quebra">{{ s.fluxo?.nome || '-' }}</span></dd>

            <dt>Etapa</dt>
            <dd><span class="info-valor-quebra">{{ s.etapa?.nome || '-' }}</span></dd>

            <dt>Número</dt>
            <dd>
              {{ s.conta?.nome || '-' }}
              @if (s.conta?.numero) {
                <span class="at-sub-valor">{{ s.conta?.numero }}</span>
              }
            </dd>

            <dt>Aberta em</dt>
            <dd>{{ s.dataInicio ? (s.dataInicio | date: 'dd/MM/yyyy - HH:mm') : '-' }}</dd>

            <dt>Última mensagem</dt>
            <dd>{{ s.ultimaMensagem ? (s.ultimaMensagem | date: 'dd/MM/yyyy - HH:mm') : '-' }}</dd>

            @if (s.dataFim) {
              <dt>Fechada em</dt>
              <dd>{{ s.dataFim | date: 'dd/MM/yyyy - HH:mm' }}</dd>
            }
          </dl>
        </section>
      }

    }
  </div>

  <footer class="info-rodape">
    <button type="button" class="info-btn-secundario" (click)="fechar()">Fechar</button>
  </footer>
</div>
